import { Drawing } from "./drawing";
import { Chain } from "../base/chain";
import { Pt, pt, ptEquals } from "../base/pt";
import { Segment, LineSegment, CurveSegment } from "../base/segment";

const HandleSize = 3;
const Style = `
<style>
        text {
          paint-order: stroke;
          font: 10px arial;
          fill: black;
          stroke: white;
          stroke-width: 3;
          text-align: center;
        }
        .handle {
          visibility: hidden
        }
        .anchor {
          visibility: hidden;
        }

        svg:hover .handle {
          visibility: visible
        }

        svg:hover .anchor {
          visibility: visible
        }

        .label {
          visibility: visible
        }
        svg:hover .label {
          visibility: hidden
        }
      </style>
`;

function handles(drawing: Drawing): string[] {
  const labels = drawing.points.flatMap((p, i) => [
    handle(p),
    `<text class="handle" x="${p.x}" y="${p.y}">${i}</text>`,
  ]);
  return [anchor(drawing.anchor)].concat(labels);
}

function handle(p: Pt): string {
  return `<circle class="handle" cx="${p.x}" cy="${p.y}" r="${HandleSize}" />`
}

function anchor(p: Pt): string {
  return `<rect class="anchor" x="${p.x - HandleSize}" y="${p.y - HandleSize}" width="${HandleSize * 2}" height="${HandleSize * 2}"/>`
}

function labels(drawing: Drawing): string[] {
  let elements = [];
  for (let pair of drawing.labels)
    elements.push(
      `<text class="label" x="${pair[1].x}" y="${pair[1].y}">${pair[0]}</text>`
    );
  return elements;
}

function vertex(p: Pt): string {
  return p.x + " " + p.y;
}

function segmentElement(s: Segment): string {
  if (s instanceof LineSegment) {
    return "L " + vertex(s.end);
  } else if (s instanceof CurveSegment) {
    return "C " + vertex(s.p1) + ", " + vertex(s.p2) + ", " + vertex(s.end);
  }
}

function element(e: Element): string {
  return `<path
    fill="${e.fill}"
    stroke="${e.stroke}"
    fill-opacity="${e.opacity}"
    d="M ${vertex(e.chain.segments[0].start)} ${e.chain.segments
      .map((s) => segmentElement(s))
      .join(" ")}"
/>`;
}

function svg(drawing: Drawing): string {
  let topLeft = pt(drawing.bounds.lowX, drawing.bounds.lowY);
  let normalized = drawing.move(10 - topLeft.x, 10 - topLeft.y)

  let elements = normalized
    .elements
    .map((e) => element(e))
    .concat(labels(normalized))
    .concat(handles(normalized));
  let width = (normalized.bounds.highX + 10).toString();
  let height = (normalized.bounds.highY + 10).toString();

  return `<svg
    xmlns="http://www.w3.org/2000/svg"  
    width="${width}"
    height="${height}">
      ${Style}
      ${elements.join("\n")}
    </g>
    </svg>`;
}

interface Element {
  chain: Chain;
  stroke: string;
  fill: string;
  opacity: number;
}

export { svg, Element };
